/**
 * Each chat's agents, by the chat's id, as app state keeps them (state.tsx).
 * Pure, so they are tested rather than read off the sidebar.
 */

import type { ChatSummary } from '../api';

export type AgentLists = Record<string, ChatSummary[]>;

/** An agent in place, or last: it keeps the place it started in. */
export function putAgent(lists: AgentLists, chat: ChatSummary): AgentLists {
  const parentId = chat.agent!.parentChatId;
  const row = { ...chat, live: chat.live ?? null };
  const list = lists[parentId] ?? [];
  return {
    ...lists,
    [parentId]: list.some((a) => a.id === chat.id) ? list.map((a) => (a.id === chat.id ? row : a)) : [...list, row]
  };
}

/** A chat gone: as an agent, and with its own agents. */
export function withoutChat(lists: AgentLists, id: string): AgentLists {
  const next: AgentLists = {};
  for (const [parentId, list] of Object.entries(lists)) if (parentId !== id) next[parentId] = list.filter((a) => a.id !== id);
  return next;
}
